import Cookies from "js-cookie";
import React from "react";

import initEmarsysForm from "../../utils/Emarsys";
import { gaEventNoHit } from "../../shared/helpers/gtm_tracking";
import { pushGa4Event } from "../../shared/helpers/ga4_helper";

import style from "./newsletter.module.scss";

const NEWSLETTER_CAMPAIGN_ID = "1259";
const NEWSLETTER_COOKIE = "hide_newsletter_signup";
const NEWSLETTER_POPOVER_COOKIE = "hide_newsletter_tip";

function loadReCaptcha() {
  const script = document.createElement("script");

  script.async = true;
  script.src = "https://www.google.com/recaptcha/api.js";
  document.head.appendChild(script);
}

export default class Newsletter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recaptchad: false,
      visible: props.modal || false,
      submitting: false,
      succeeded: false,
      failed: false
    };
  }

  componentDidMount() {
    if (this.state.visible) {
      this.initForm();
    }
  }

  setFailedState = () => {
    this.setState({ failed: true, submitting: false });
  };

  setSucceededState = () => {
    this.setState({ succeeded: true, submitting: false, visible: false });
    this.toggleReCaptcha(false);
    gaEventNoHit("Goals", "Newsletter", "Success");
    pushGa4Event({
      event: "generate_lead",
      lead_type: "Newsletter Signup"
    });
    this.setCookies();
    this.hidePopover();
  };

  setCookies() {
    [NEWSLETTER_COOKIE, NEWSLETTER_POPOVER_COOKIE].forEach(cookie => {
      Cookies.set(cookie, "true", { expires: 20 * 365, samesite: "lax" });
    });
  }

  initForm = () => {
    initEmarsysForm(
      this.form,
      {
        submit: () => {
          this.setState({ failed: false, submitting: true });
        }
      },
      { success: this.setSucceededState, fail: this.setFailedState }
    );
  };

  hidePopover() {
    const popover = document.querySelector(`[data-popover][data-cookie=${NEWSLETTER_POPOVER_COOKIE}]`);

    if (popover) {
      popover.classList.add("hide");
    }
  }

  toggleReCaptcha(show) {
    const recaptcha = document.querySelector('.g-recaptcha');

    if (!recaptcha) {
      return;
    }

    const chatButtons = document.getElementById("js-chat-buttons")
    const method = show ? 'add' : 'remove';

    if (chatButtons) {
      chatButtons.classList[method]("hide")
    }

    recaptcha.classList[method]('show');
  }

  showForm = () => {
    const { recaptchad } = this.state;

    if (!recaptchad) {
      loadReCaptcha();
      this.setState({ recaptchad: true });
    }

    this.setState({ visible: true }, this.initForm);
    this.toggleReCaptcha(true);
    gaEventNoHit("Goals", "Newsletter", "Open Form");
  };

  renderForm() {
    return (
      <form
        className={style.form}
        ref={ref => { this.form = ref; }}
        autoComplete="on"
        data-emarsys-form
        data-campaign-id={NEWSLETTER_CAMPAIGN_ID}
      >
        <div className="form-group form-control__placeholder-label">
          <label htmlFor="inp_1">First name</label>
          <input
            type="text"
            name="inp_1"
            id="inp_1"
            placeholder="First name"
            className="form-control form-control--custom js-floating-placeholder"
            maxLength="50"
            autoComplete="given-name"
            required
          />
        </div>
        <div className="form-group form-control__placeholder-label">
          <label htmlFor="inp_2">Last name</label>
          <input
            type="text"
            name="inp_2"
            id="inp_2"
            placeholder="Last name"
            className="form-control form-control--custom js-floating-placeholder"
            maxLength="50"
            autoComplete="family-name"
            required
          />
        </div>
        <div className="form-group form-control__placeholder-label">
          <label htmlFor="inp_3">Email</label>
          <input
            type="email"
            name="inp_3"
            id="inp_3"
            placeholder="Email"
            className="form-control form-control--custom js-trim-email js-floating-placeholder"
            maxLength="254"
            autoComplete="email"
            required
          />
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="btn btn-lg button--alt--solid gtm-track-click"
            data-gtm-category="All Pages"
            data-gtm-action="Newsletter"
            data-gtm-label="Clicked Submit"
            disabled={this.state.submitting}
          >
            Get the latest deals
          </button>
        </div>
      </form>
    );
  }

  render() {
    if (Cookies.get(NEWSLETTER_COOKIE)) {
      return null;
    }

    const { wrapper, container, icon, content, heading, cta } = style;
    const { modal } = this.props;
    const { failed, succeeded, visible } = this.state;

    return (
      <div className={wrapper}>
        <div className={container}>
          <div className={icon}>
            <i className="fa fa-2x fa-fw fa-envelope-o"></i>
          </div>

          <div className={content}>
            {modal && !succeeded &&
              <div className="h3">
                Join today & get great golf holiday deals!
              </div>
            }

            {visible && this.renderForm()}

            {succeeded &&
              <div className={heading}>
                Thanks, your deals are on their way!
              </div>
            }

            {failed &&
              <div>
                Oops! Something went wrong, would you mind trying again?
              </div>
            }

            {!modal && !visible && !succeeded &&
              <div>
                <div className={heading}>Never miss a deal!</div>
                <div>Sign up to receive our newsletter</div>
              </div>
            }
          </div>

          {!visible && !succeeded &&
            <div className={cta}>
              <button
                className="btn btn-lg button--alt--solid gtm-track-click"
                data-gtm-category="All Pages"
                data-gtm-action="Newsletter"
                data-gtm-label="Clicked Sign Up"
                type="button"
                onClick={this.showForm}
              >
                Sign up
              </button>
            </div>
          }
        </div>

        <div>
          <a href="/privacy">
            <small>
              Learn more about how YourGolfTravel collects and uses personal
              data.
            </small>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/newsletter/newsletter.jsx